import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    List,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@material-ui/core';
import { TruckIncomeReportCss as useStyles } from './ReportSideBarCss';
import RightSideBar from '../RightSideBar/RightSideBar';
import { getAllPnlMonths } from '../../../store/actions/homeActionCreator';
import { fetchTruckIncomeReport } from '../../../store/actions/tripActionCreator';
import FilterComponent from '../FilterComponent/FilterComponent';
import * as logger from '../../../logger';
import AddIcon from '@material-ui/icons/Add';
import { set } from 'date-fns';
import MUIDataTable from "mui-datatables";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { vehicleMonthlyPnlReport, truckIncomeExcel } from '../../../store/actions/vehicleActionCreator';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { numberFormat } from '../../../utils/utils';
import ReportsDialog from '../ReportsDialog/ReportsDialog';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import InfoDialog from '../Dialog/InfoDialog';
import { trackDwebEvent } from '../../analytics';

const TruckIncomeReport = ({ user, trip, open, onClose, dispatchGetPnlMonths, dispatchGetTruckIncomeReport, dispatchGetMonthlyProfitLoss, vehicle, dispatchGetTruckIncomeExcel, handleAddTrip }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [showExcelDownloadButton, setShowExcelDownloadButton] = useState(false);
    const [dateFilterValue, setDateFilterValue] = useState("");
    const [changeDataFlag, setChangeDataFlag] = useState(false);
    const [truckReportData, setTruckReportData] = useState({});
    const [myTruckList, setMyTruckList] = useState([]);
    const [marketTruckList, setMarketTruckList] = useState([]);
    const [profitLossData, setProfitLossData] = useState([]);
    const [vehicleId, setVehicleId] = useState("");
    const [montlyReport, setMontlyReport] = useState(false);
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);
    const [pdfMonthValue, setPdfMonthValue] = useState("");
    const [collapseKeys, setCollapseKeys] = useState({});
    const [myTruckProfitLoss, setMyTruckProfitLoss] = useState("");
    const [vehicleNumber, setVehicleNumber] = useState([]);
    const [marketTruckProfitLoss, setMarketTruckProfitLoss] = useState("");
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState("");
    const [infoText, setInfoText] = useState("");
    const [bodyType, setBodyType] = useState("");

    const getMuiTheme = (type) => createMuiTheme({
        overrides: {
            MUIDataTableBodyCell: {
                root: {
                    backgroundColor: "#FF0000"
                }
            },
            MuiList: {
                padding: {
                    paddingTop: 0,
                    paddingBottom: 0
                }
            },
            MUIDataTable: {
                paper: {
                    //padding:24
                    boxShadow: 'inset 0 -1px 0 0 #e1e1e1',
                    borderRadius: '6px !important',
                },
                responsiveBase: {
                    border: '1px solid #dfe2e5',
                    borderRadius: 6,
                    //maxHeight: 'calc(100vh - 370px) !important',
                    //height: 'auto !important'
                }
            },
            MUIDataTableHead: {
            },
            MUIDataTableBodyRow: {
                root: {
                    height: 42,
                    maxHeight: 42,
                    minHeight: 42,
                    fontWeight: 300,
                    cursor: 'pointer',
                    '&:nth-of-type(even)': {
                        backgroundColor: '#f6f6f8',
                    },
                    '&:last-child': {
                        cursor: 'default',
                        backgroundColor: type == "myTruck" ? myTruckProfitLoss ? myTruckProfitLoss == "loss" ? '#d71e1d' : myTruckProfitLoss == "profit" ? '#00875a' : "" : "" : type == "marketTruck" ? marketTruckProfitLoss ? marketTruckProfitLoss == "loss" ? '#d71e1d' : marketTruckProfitLoss == "profit" ? '#00875a' : "" : "" : "",
                        '&:hover': {
                            backgroundColor: type == "myTruck" ? myTruckProfitLoss ? myTruckProfitLoss == "loss" ? '#d71e1d' : myTruckProfitLoss == "profit" ? '#00875a' : "" : "" : type == "marketTruck" ? marketTruckProfitLoss ? marketTruckProfitLoss == "loss" ? '#d71e1d' : marketTruckProfitLoss == "profit" ? '#00875a' : "" : "" : "",
                        }
                    }
                }
            },
            MUIDataTableSelectCell: {
                fixedHeader: {
                    backgroundColor: "#f1f1f3"
                },
                headerCell: {
                    backgroundColor: "#f1f1f3"
                }
            },
            MUIDataTableHeadCell: {
                root: {
                    backgroundColor: "#f1f1f3",
                    fontWeight: 'bold',
                    textAlign: 'end',
                    '&:first-child': {
                        textAlign: 'start'
                    }
                },
                sortLabelRoot: {
                    height: 'auto'
                },
                fixedHeader: {
                    backgroundColor: "#d7dfe5",
                    paddingBottom: 10,
                    paddingTop: 10,
                    top: -1
                }
            },
            MUIDataTableBodyCell: {
                root: {
                    fontWeight: 'bold',
                    color: '#161f34'
                },
                stackedParent: {
                    borderTop: 'none',
                    paddingTop: 8,
                    paddingBottom: 8,
                    textAlign: 'end',
                    '&:first-child': {
                        textAlign: 'start'
                    },
                    '&:last-child': {
                        paddingLeft: '2px !important',
                        paddingRight: '8px !important',
                        width: 17,
                        maxWidth: 17
                    }
                }
            },
        }
    })


    const classes = useStyles();

    useEffect(() => {

        if (vehicle.profitLossMonthly) {
            setProfitLossData(vehicle.profitLossMonthly);
        }

    }, [vehicle.profitLossMonthly]);

    useEffect(() => {
        vehicle.profitLossMonthly = {}
        dispatchGetPnlMonths(
            (data) => {
                // if (data && data.status && data.status.code == 200) {
                logger.log("Truck Income Report Dweb", 'Get PNL months successfull');

                const filterValue = {
                    monthYear: data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : ""
                };
                trackDwebEvent("Dweb Truck Income Report", {
                    default_month: data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : ""
                });
                setDateFilterValue(data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : "");

                dispatchGetTruckIncomeReport(filterValue,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Truck Income Report Dweb", "Get Truck Income Report Successfull");
                        }
                    },
                    () => {
                        logger.log("Truck Income Report Dweb", "Get Truck Income Report Failed");
                    }
                );
                // }
            },
            () => {
                logger.log("Truck Income Report Dweb", 'Get PNL months failed');
            }
        );

    }, [open]);

    useEffect(() => {

        if (changeDataFlag) {
            const filterValue = {
                monthYear: dateFilterValue ? dateFilterValue : ""
            };

            dispatchGetTruckIncomeReport(filterValue,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Truck Income Report Dweb", "Get Truck Income Report Successfull");
                    }
                },
                () => {
                    logger.log("Truck Income Report Dweb", "Get Truck Income Report Failed");
                }
            );
        }

    }, [dateFilterValue]);

    useEffect(() => {

        if (trip && trip.truckIncomeReport) {

            setTruckReportData(trip.truckIncomeReport)

            if (trip.truckIncomeReport.hired && trip.truckIncomeReport.hired.lineItems && trip.truckIncomeReport.hired.lineItems.length > 0) {
                trip.truckIncomeReport.hired.lineItems.push(
                    {
                        number: "Total",
                        expenses: trip.truckIncomeReport.hired.overall && trip.truckIncomeReport.hired.overall.expenses ? trip.truckIncomeReport.hired.overall.expenses : "",
                        profit: trip.truckIncomeReport.hired.overall && trip.truckIncomeReport.hired.overall.profit ? trip.truckIncomeReport.hired.overall.profit : "",
                        revenue: trip.truckIncomeReport.hired.overall && trip.truckIncomeReport.hired.overall.revenue ? trip.truckIncomeReport.hired.overall.revenue : ""
                    }
                );

                setMarketTruckList(trip.truckIncomeReport.hired.lineItems);
            } else {
                setMarketTruckList([]);
            }

            if (trip.truckIncomeReport.own && trip.truckIncomeReport.own.lineItems && trip.truckIncomeReport.own.lineItems.length > 0) {
                trip.truckIncomeReport.own.lineItems.push(
                    {
                        number: "Total",
                        expenses: trip.truckIncomeReport.own.overall && trip.truckIncomeReport.own.overall.expenses ? trip.truckIncomeReport.own.overall.expenses : "",
                        profit: trip.truckIncomeReport.own.overall && trip.truckIncomeReport.own.overall.profit ? trip.truckIncomeReport.own.overall.profit : "",
                        revenue: trip.truckIncomeReport.own.overall && trip.truckIncomeReport.own.overall.revenue ? trip.truckIncomeReport.own.overall.revenue : ""
                    }
                )

                setMyTruckList(trip.truckIncomeReport.own.lineItems);

            } else {
                setMyTruckList([]);
            }

            if (trip && trip.truckIncomeReport && trip.truckIncomeReport.emptyStateTitle) {
                setShowExcelDownloadButton(false);
            } else {
                setShowExcelDownloadButton(true);
            }

            if (trip.truckIncomeReport.own && trip.truckIncomeReport.own.overall && (trip.truckIncomeReport.own.overall.expenses < 0 || trip.truckIncomeReport.own.overall.profit < 0 || trip.truckIncomeReport.own.overall.revenue < 0)) {
                setMyTruckProfitLoss("loss");
            } else {
                setMyTruckProfitLoss("profit");
            }

            if (trip.truckIncomeReport.hired && trip.truckIncomeReport.hired.overall && (trip.truckIncomeReport.hired.overall.expenses < 0 || trip.truckIncomeReport.hired.overall.profit < 0 || trip.truckIncomeReport.hired.overall.revenue < 0)) {
                setMarketTruckProfitLoss("loss");
            } else {
                setMarketTruckProfitLoss("profit");
            }
        }

    }, [trip.truckIncomeReport]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        setTruckReportData({});
        trip.truckIncomeReport = {}
    }

    const handleDownloadExcel = () => {

        let monthYear;
        if (dateFilterValue) {
            monthYear = dateFilterValue;
        } else {
            monthYear = user && user.pnlMonths && user.pnlMonths[0] ? user.pnlMonths[0] : "";
        }

        dispatchGetTruckIncomeExcel(monthYear,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Truck Income Report Dweb", "Get Excel link successfull");
                    if (data && data.response && data.response.s3Link) {
                        window.open(data.response.s3Link);
                        trackDwebEvent("Dweb Truck Income Report Excel Download", {
                            default_month: monthYear
                        });
                    }
                }
            },
            () => {
                logger.log("Truck Income Report Dweb", "Get Excel link failed");
            }
        )

    }

    const handleBackClick = () => {
        dispatchGetPnlMonths(
            (data) => {
                // if (data && data.status && data.status.code == 200) {
                logger.log("Truck Income Report Dweb", 'Get PNL months successfull');

                const filterValue = {
                    monthYear: dateFilterValue ? dateFilterValue : ""
                };

                dispatchGetTruckIncomeReport(filterValue,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Truck Income Report Dweb", "Get Truck Income Report Successfull");
                            setShowExcelDownloadButton(true);
                            setMontlyReport(false);
                        }
                    },
                    () => {
                        logger.log("Truck Income Report Dweb", "Get Truck Income Report Failed");
                    }
                );
                // }
            },
            () => {
                logger.log("Truck Income Report Dweb", 'Get PNL months failed');
            }
        );
    }

    const handlePnlDate = (dateValue) => {
        setDateFilterValue(dateValue);
        setChangeDataFlag(true);
    }

    const muiDataMyTruck = myTruckList ? myTruckList : [];
    const muiDataHiredTruck = marketTruckList ? marketTruckList : [];

    const muiColumnsMyTruck = [
        {
            name: "number",
            label: "Truck No",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].number ? muiDataMyTruck[dataIndex].number.split(" ") : "";
                    return (
                        <>
                            {truckNumber.map((number, index) => (
                                <span className={truckNumber == "Total" ? classes.textV3 : index > 0 ? classes.textV1 : ""}>
                                    {number}
                                </span>
                            ))}
                        </>
                    );
                }
            },
        },
        {
            name: "revenue",
            label: "Revenue",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].number ? muiDataMyTruck[dataIndex].number : ""
                    return (
                        <>
                            <div className={truckNumber == "Total" ? classes.divColorWhite : classes.revenue} >
                                {muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].revenue ? numberFormat(muiDataMyTruck[dataIndex].revenue) : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "expenses",
            label: "Expenses",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].number ? muiDataMyTruck[dataIndex].number : ""
                    return (
                        <>
                            <div className={truckNumber == "Total" ? classes.divColorWhite : classes.expenses}>
                                {muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].expenses ? numberFormat(muiDataMyTruck[dataIndex].expenses) : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "profit",
            label: "Profit",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].number ? muiDataMyTruck[dataIndex].number : ""
                    return (
                        <>
                            <div className={truckNumber == "Total" ? classes.divColorWhite : muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].profit && muiDataMyTruck[dataIndex].profit < 0 ? classes.dataLossV1 : ""}>
                                <span>
                                    {muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].profit ? numberFormat(muiDataMyTruck[dataIndex].profit) : 0}
                                </span>
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            <div>
                                {muiDataMyTruck && muiDataMyTruck[dataIndex] && muiDataMyTruck[dataIndex].number && muiDataMyTruck[dataIndex].number != "Total" &&
                                    <KeyboardArrowRightIcon className={classes.arrowIcon} />
                                }
                            </div>
                        </>
                    );
                }
            },
        }
    ];

    const muiColumnsHiredTruck = [
        {
            name: "number",
            label: "Truck No",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].number ? muiDataHiredTruck[dataIndex].number.split(" ") : "";
                    return (
                        <>
                            {truckNumber.map((number, index) => (
                                <span className={truckNumber == "Total" ? classes.textV3 : index > 0 ? classes.textV1 : ""}>
                                    {number}
                                </span>
                            ))}
                        </>
                    );
                }
            },
        },
        {
            name: "revenue",
            label: "Revenue",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].number ? muiDataHiredTruck[dataIndex].number : "";
                    return (
                        <>
                            <div className={truckNumber == "Total" ? classes.divColorWhite : classes.revenue}>
                                {muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].revenue ? numberFormat(muiDataHiredTruck[dataIndex].revenue) : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "expenses",
            label: "Expenses",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].number ? muiDataHiredTruck[dataIndex].number : "";
                    return (
                        <>
                            <div className={truckNumber == "Total" ? classes.divColorWhite : classes.expenses}>
                                {muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].expenses ? numberFormat(muiDataHiredTruck[dataIndex].expenses) : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "profit",
            label: "Profit",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const truckNumber = muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].number ? muiDataHiredTruck[dataIndex].number : "";
                    return (
                        <>
                            <div className={truckNumber == "Total" ? classes.divColorWhite : muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].profit && muiDataHiredTruck[dataIndex].profit < 0 ? classes.dataLossV1 : ""}>
                                {muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].profit ? numberFormat(muiDataHiredTruck[dataIndex].profit) : 0}
                            </div>
                        </>
                    );
                }
            },
        },
        {
            name: "",
            label: "",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            <div>
                                {muiDataHiredTruck && muiDataHiredTruck[dataIndex] && muiDataHiredTruck[dataIndex].number && muiDataHiredTruck[dataIndex].number != "Total" &&
                                    <KeyboardArrowRightIcon className={classes.arrowIcon} />
                                }
                            </div>
                        </>
                    );
                }
            },
        }
    ];

    const optionsMyTruck = {
        filterType: "multiselect",
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        sort: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        onRowClick: (rowData, rowMeta) => {
            handleRowClick(muiDataMyTruck[rowMeta.dataIndex])
        },
    }

    const optionsHiredTruck = {
        filterType: "multiselect",
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        sort: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        pagination: false,
        onRowClick: (rowData, rowMeta) => {
            handleRowClick(muiDataHiredTruck[rowMeta.dataIndex])
        },
    }

    const handleRowClick = (truckData) => {
        if (truckData && truckData.number && truckData.number != "Total") {
            setVehicleId(truckData.id);
            setVehicleNumber(truckData.number.split(" "));

            if (truckData && truckData.bodyType && truckData.bodyType == "OPEN") {
                setBodyType("Open Body");
            } else if (truckData && truckData.bodyType && truckData.bodyType == "CLOSE") {
                setBodyType("Closed Body");
            } else if (truckData && truckData.bodyType) {
                setBodyType((truckData.bodyType).toLowerCase());
            }

            trackDwebEvent("Dweb Truck Income Report Truck Selected", {
                truck_id: truckData.id,
                truck_number: truckData.number
            });

            const requestData = {
                "vehicleId": truckData && truckData.id ? truckData.id : "",
                "pageSize": 12,
                "pageNo": 1
            }

            dispatchGetMonthlyProfitLoss(requestData,
                (data) => {
                    logger.log("Truck Income Report Dweb", "Get vehicle monthly Profit Loss Report Successfull");
                    setMontlyReport(true);
                    setShowExcelDownloadButton(false);
                },
                () => {
                    logger.log("Truck Income Report Dweb", "Get vehicle monthly Profit Loss Report Failed");
                }
            )
        }
    }

    const handleViewPdf = (item) => {
        setPdfDialogOpen(true);
        setPdfMonthValue(item.pdfMonth);
    }

    const handleClosePdf = () => {
        setPdfDialogOpen(false);
    }

    const handleCollapseClick = (key) => {
        setCollapseKeys({ [key]: collapseKeys[key] ? false : true });
    }

    const handleInfoClick = (infoType) => {

        if (infoType == "Trip Started") {
            setInfoOpen(true);
            setInfoTitle(infoType);
            setInfoText("Total number of trips started during this month");
        } else if (infoType == "Last Trip KM") {
            setInfoOpen(true);
            setInfoTitle(infoType);
            setInfoText("The KM value taken from the last trip of the month");
        } else if (infoType == "Refuel Qty.") {
            setInfoOpen(true);
            setInfoTitle("Refuel Quantity");
            setInfoText("Total refuel quantity for all the fuel expenses added for this vehicle during the month. Please make sure to add quantity when you add fuel expense");
        }

    }

    const handleInfoClose = () => {
        setInfoOpen(false);
        setInfoTitle("");
        setInfoText("");
    }

    return (
        <>
            {open && <RightSideBar
                rightSideBarOpen={dialogOpen}
                sideBarTitle={'Truck Revenue Report'}
                sideBarType="reports"
                handleSubmit={event => handleDownloadExcel(event)}
                toggleRightSideBar={handleClose}
                showDownloadExcel={showExcelDownloadButton}
                backClick={handleBackClick}
                showBackReports={montlyReport}
                vehicleNumberValue={vehicleNumber}
                truckType={bodyType}
                fromTruckIncomeReport={true}
                titleType="reports"
            >
                <>
                    {!montlyReport &&
                        <div className={classes.divFilter}>
                            <FilterComponent reportType={"Truck Income Report"} pnlDate={handlePnlDate} defaultValue={dateFilterValue} />
                        </div>
                    }
                    {!montlyReport &&
                        <>
                            {truckReportData && truckReportData.emptyStateTitle &&
                                <div className={classes.divEmptyState}>
                                    <div>
                                        <img src={truckReportData.icon} className={classes.imgV1} >
                                        </img>
                                    </div>
                                    <div className={classes.divEmptyText}>
                                        {truckReportData.emptyStateTitle}
                                    </div>
                                    <div>
                                        <Button variant="contained" className={classes.addTripButton} onClick={handleAddTrip} >
                                            <AddIcon />
                                            <span>
                                                Add Trip
                                            </span>
                                        </Button>
                                    </div>
                                </div>
                            }
                            {truckReportData && !truckReportData.emptyStateTitle &&
                                <div>
                                    <div className={classes.divTables}>
                                        <div className={classes.divRow}>
                                            <div className={classes.divTopCard}>
                                                <div className={classes.divTitleV1}>Total Revenue</div>
                                                <div className={classes.divData}>{truckReportData && truckReportData.overall && truckReportData.overall.revenue ? numberFormat(truckReportData.overall.revenue) : "--"}</div>
                                            </div>
                                            <div className={classes.divTopCard}>
                                                <div className={classes.divTitleV1}>Total Expenses</div>
                                                <div className={classes.divData}>{truckReportData && truckReportData.overall && truckReportData.overall.expenses ? numberFormat(truckReportData.overall.expenses) : "--"}</div>
                                            </div>
                                            <div className={classes.divTopCard}>
                                                <div className={classes.divTitleV1}>Total Profit</div>
                                                <div className={truckReportData && truckReportData.overall && truckReportData.overall.profit && truckReportData.overall.profit < 0 ? classes.divDataLoss : classes.divData}>{truckReportData && truckReportData.overall && truckReportData.overall.profit ? numberFormat(truckReportData.overall.profit) : "--"}</div>
                                            </div>
                                        </div>
                                        {muiDataMyTruck && muiDataMyTruck.length > 0 &&
                                            <div className={classes.mtV2}>
                                                <div className={classes.divTitle}>My Trucks</div>
                                                <div className={classes.mtV1}>
                                                    <MuiThemeProvider theme={getMuiTheme('myTruck')}>
                                                        {/* <div className={myTruckProfitLoss == "loss" ? classes.rowLoss : myTruckProfitLoss == "profit" ? classes.rowProfit : ""}> */}
                                                        <MUIDataTable title={""} data={muiDataMyTruck} columns={muiColumnsMyTruck} options={optionsMyTruck} />
                                                        {/* </div> */}
                                                    </MuiThemeProvider>
                                                </div>
                                            </div>
                                        }
                                        {muiDataHiredTruck && muiDataHiredTruck.length > 0 &&
                                            <div className={classes.mtV2}>
                                                <div className={classes.divTitle}>Market Trucks</div>
                                                <div className={classes.mtV1}>
                                                    <MuiThemeProvider theme={getMuiTheme('marketTruck')}>
                                                        <MUIDataTable title={""} data={muiDataHiredTruck} columns={muiColumnsHiredTruck} options={optionsHiredTruck} />
                                                    </MuiThemeProvider>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </>
                    }

                    {montlyReport &&
                        <div className={classes.divMonthlyReport}>
                            {profitLossData && profitLossData.lineItems && profitLossData.lineItems.length > 0 && profitLossData.lineItems.map((data, key) => (
                                < div style={{ marginBottom: 34 }}>
                                    <div className={classes.divAlign}>
                                        <div className={classes.divMonth}>{data.month}</div>
                                        <div className={classes.divPdf} onClick={() => handleViewPdf(data)}>
                                            <div className={classes.mrV1}><PictureAsPdfIcon /></div>
                                            <div>View PDF</div>
                                        </div>
                                    </div>
                                    <Card className={classes.cardV1}>
                                        <CardContent className={classes.cardContentV1}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <div>
                                                    <div className={classes.divTitleV2}>Trip Started
                                                        <InfoOutlinedIcon className={classes.infoIcon} onClick={() => handleInfoClick('Trip Started')} />
                                                    </div>
                                                    <div className={classes.divValue}>{data.noOfTrips == 1 ? data.noOfTrips + ' Trip' : data.noOfTrips + " Trips"}</div>
                                                </div>
                                                <div>
                                                    <div className={classes.divTitleV2}>Last Trip KM
                                                        <InfoOutlinedIcon className={classes.infoIcon} onClick={() => handleInfoClick('Last Trip KM')} />
                                                    </div>
                                                    <div className={classes.divValue}>{data.kmReading ? data.kmReading : '--'}</div>
                                                </div>
                                                <div>
                                                    <div className={classes.divTitleV2}>Refuel Qty.
                                                        <InfoOutlinedIcon className={classes.infoIcon} onClick={() => handleInfoClick('Refuel Qty.')} />
                                                    </div>
                                                    <div className={classes.divValue}>{data.refuelQuantity ? data.refuelQuantity : '--'}</div>
                                                </div>
                                            </div>

                                            <hr className={classes.hrV1} />

                                            <div>
                                                {data.revenueItems && data.revenueItems.length == 0 &&
                                                    <div className={classes.divAlign}>
                                                        <div className={classes.divTitleV3}>Revenue</div>
                                                        <div className={classes.divValueV1}>{numberFormat(data.totalRevenue)}</div>
                                                    </div>
                                                }
                                                {data.revenueItems && data.revenueItems.length > 0 &&
                                                    <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`revenue${key}collapse`)}>
                                                        <AccordionSummary
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                            classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                        >
                                                            <div className={classes.divAlignV1}>
                                                                <div className={classes.dFlex}>
                                                                    <div className={classes.divTitleV3}>Revenue</div>
                                                                    {collapseKeys && collapseKeys[`revenue${key}collapse`] ?
                                                                        <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                        :
                                                                        <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                                    }
                                                                </div>
                                                                <div className={classes.divValueV1}>{numberFormat(data.totalRevenue)}</div>
                                                            </div>
                                                        </AccordionSummary>
                                                        <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                            <div className={classes.divItems}>
                                                                {data.revenueItems.map((revenue) => (
                                                                    <div className={classes.divItemsV1}>
                                                                        <div className={classes.divAlignV2}>
                                                                            <div className={classes.divAlignV3}>
                                                                                <div className={classes.fwbold}>{revenue.startDate}</div>
                                                                                <span className={classes.bullet}>•</span>
                                                                                <div>{revenue.originLocation}&nbsp;-&nbsp;{revenue.destinationLocation} </div>
                                                                            </div>
                                                                            <div>{numberFormat(revenue.amount)}</div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                                }
                                                            </div>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                }
                                            </div>

                                            <div className={classes.mtV1}>
                                                {data.expenseItems && data.expenseItems.length == 0 && data.hiredExpenseItems && data.hiredExpenseItems.length == 0 &&
                                                    <div className={classes.divAlign}>
                                                        <div className={classes.divTitleV3}>Expenses</div>
                                                        <div className={classes.fwbold}>{numberFormat(data.totalExpenses)}</div>
                                                    </div>
                                                }
                                                {data.expenseItems && data.expenseItems.length > 0 &&
                                                    <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`expenses${key}collapse`)}>
                                                        <AccordionSummary
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                            classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                        >
                                                            <div className={classes.divAlignV1}>
                                                                <div className={classes.dFlex}>
                                                                    <div className={classes.divTitleV3}>Expenses</div>
                                                                    {collapseKeys && collapseKeys[`expenses${key}collapse`] ?
                                                                        <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                        :
                                                                        <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                                    }
                                                                </div>
                                                                <div className={classes.fwbold}>{numberFormat(data.totalExpenses)}</div>
                                                            </div>
                                                        </AccordionSummary>
                                                        <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                            <div className={classes.divItems}>
                                                                {data.expenseItems.map((expense) => (
                                                                    <div className={classes.divItemsV1}>
                                                                        <div className={classes.divAlignV2}>
                                                                            <div className={classes.fwbold}>
                                                                                {expense.displayName}
                                                                            </div>
                                                                            <div>{numberFormat(expense.amount)}</div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                                }
                                                            </div>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                }
                                                {data.hiredExpenseItems && data.hiredExpenseItems.length > 0 &&
                                                    <Accordion classes={{ root: classes.boxShadow }} onChange={() => handleCollapseClick(`expenses${key}collapse`)}>
                                                        <AccordionSummary
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header"
                                                            classes={{ content: classes.divCenter, root: classes.rootV1 }}
                                                        >
                                                            <div className={classes.divAlignV1}>
                                                                <div className={classes.dFlex}>
                                                                    <div className={classes.divTitleV3}>Expenses</div>
                                                                    {collapseKeys && collapseKeys[`expenses${key}collapse`] ?
                                                                        <ArrowDropUpIcon className={classes.arrowUpV1} />
                                                                        :
                                                                        <ArrowDropDownIcon className={classes.arrowDownV1} />
                                                                    }
                                                                </div>
                                                                <div className={classes.fwbold}>{numberFormat(data.totalExpenses)}</div>
                                                            </div>
                                                        </AccordionSummary>
                                                        <AccordionDetails classes={{ root: classes.pdV1 }}>
                                                            <div className={classes.divItems}>
                                                                {data.hiredExpenseItems.map((expense) => (
                                                                    <div className={classes.divItemsV1}>
                                                                        <div className={classes.divAlignV2}>
                                                                            <div className={classes.divAlignV3}>
                                                                                <div className={classes.fwbold}>{expense.startDate}</div>
                                                                                <span className={classes.bullet}>•</span>
                                                                                <div>{expense.originLocation}&nbsp;-&nbsp;{expense.destinationLocation} </div>
                                                                            </div>
                                                                            <div>{numberFormat(expense.amount)}</div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                                }
                                                            </div>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                }
                                            </div>

                                            <hr className={classes.colorV2} />

                                            <div className={classes.divAlign}>
                                                <div className={classes.divProfit}>Profit</div>
                                                {data.profit > 0 &&
                                                    <div className={classes.profit}>{numberFormat(data.profit)}</div>
                                                }
                                                {data.profit < 0 &&
                                                    <div className={classes.loss}>-<span className={classes.mlV5}>{numberFormat(data.profit * -1)}</span></div>
                                                }
                                                {
                                                    data.profit == 0 &&
                                                    <div className={classes.loss}>{numberFormat(data.profit)}</div>
                                                }
                                            </div>

                                        </CardContent>
                                    </Card>
                                </div>
                            ))
                            }
                        </div>
                    }
                </>
            </RightSideBar>}
            {
                pdfDialogOpen &&
                <ReportsDialog open={pdfDialogOpen} name={"Truck Monthly Profit and Loss Report"} vehicleIdValue={vehicleId} pdfMonth={pdfMonthValue} onClose={handleClosePdf} vehicleNumberValue={vehicleNumber} reportType={"excelReports"} doNotShowExcelButton={true} />
            }
            {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={infoTitle} confirmMessage={infoText} onClose={handleInfoClose} />}

        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetPnlMonths: (onSuccess, onError) => {
        dispatch(getAllPnlMonths(null, onSuccess, onError))
    },
    dispatchGetTruckIncomeReport: (filterValue, onSuccess, onError) => {
        dispatch(fetchTruckIncomeReport(filterValue, onSuccess, onError))
    },
    dispatchGetMonthlyProfitLoss: (data, onSuccess, onFailure) => {
        dispatch(vehicleMonthlyPnlReport(data, onSuccess, onFailure))
    },
    dispatchGetTruckIncomeExcel: (filterData, onSuccess, onError) => {
        dispatch(truckIncomeExcel(filterData, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TruckIncomeReport);